import React from 'react';
import {
  Box,
  VStack,
  Spinner,
  Text,
  Heading,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaFistRaised } from 'react-icons/fa';

const MotionBox = motion(Box);

export const LoadingScreen = () => {
  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="dark.900"
      position="relative"
      overflow="hidden"
    >
      {/* Background Pattern */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bgImage="radial-gradient(circle at 20% 50%, rgba(239, 68, 68, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(239, 68, 68, 0.1) 0%, transparent 50%)"
      />

      <VStack spacing={8} position="relative" zIndex={1}>
        {/* Animated Logo */}
        <MotionBox
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <Box
            p={6}
            borderRadius="2xl"
            bg="brand.500"
            color="white"
            boxShadow="0 0 50px rgba(239, 68, 68, 0.3)"
          >
            <FaFistRaised size="48" />
          </Box>
        </MotionBox>

        {/* Brand Name */}
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <VStack spacing={2}>
            <Heading
              as="h1"
              size="xl"
              fontWeight="black"
              bgGradient="linear(to-r, white, gray.300)"
              bgClip="text"
              textAlign="center"
            >
              RIVER CITY FIGHTS
            </Heading>
            <Text color="gray.400" fontSize="sm" textAlign="center">
              Loading your fight experience...
            </Text>
          </VStack>
        </MotionBox>

        {/* Custom Spinner */}
        <MotionBox
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.6 }}
        >
          <Spinner
            thickness="3px"
            speed="0.8s"
            emptyColor="dark.700"
            color="brand.500"
            size="lg"
          />
        </MotionBox>
      </VStack>
    </Box>
  );
};
